import React from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import { useGetMe } from '../services/auth/auth';
import Header from '../components/Header';

const VideoCall = () => {
  const { roomID } = useParams();
  const [searchParams] = useSearchParams();
  const callType = searchParams.get('type') || 'video';
  const { data: currentUser, isLoading } = useGetMe();
  const navigate = useNavigate();
  const containerRef = React.useRef(null);
  const zpRef = React.useRef(null);

  React.useEffect(() => {
    const initCall = async () => {
      if (!currentUser || !roomID || !containerRef.current) return;

      try {
        const appID =1839240108;
        const serverSecret ="cded5bdf143cf98138cb1ee0d94b730c"; // MUST be the 32-character ServerSecret

        if (!appID || !serverSecret) {
          console.error('ZEGOCLOUD AppID or ServerSecret is missing in .env');
          return;
        }

        console.log('Initiating call with:', { appID, roomID, userID: currentUser._id, hasSecret: !!serverSecret });

        const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
          appID,
          serverSecret,
          roomID,
          currentUser._id.toString(),
          `${currentUser.firstName} ${currentUser.lastName}`
        );

        if (!kitToken) {
          console.error('Failed to generate ZEGOCLOUD kit token');
          return;
        }

        zpRef.current = ZegoUIKitPrebuilt.create(kitToken);
        
        if (!zpRef.current) {
          console.error('Failed to create ZEGOCLOUD instance');
          return;
        }

        zpRef.current.joinRoom({
          container: containerRef.current,
          sharedLinks: [
            {
              name: 'Personal link',
              url: window.location.protocol + '//' + window.location.host + window.location.pathname + '?type=' + callType,
            },
          ],
          scenario: {
            mode: callType === 'video' ? ZegoUIKitPrebuilt.VideoConference : ZegoUIKitPrebuilt.GroupCall,
          },
          showScreenSharingButton: true,
          showPreJoinView: true,
          onReturnToHomeScreenClicked: () => {
            navigate(`/clients/messages/${roomID}`);
          },
        });
      } catch (error) {
        console.error('ZEGOCLOUD initialization error:', error);
      }
    };

    if (!isLoading) {
      initCall();
    }

    return () => {
      if (zpRef.current) {
        zpRef.current.destroy();
        zpRef.current = null;
      }
    };
  }, [currentUser, roomID, callType, isLoading]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="h-screen w-full relative bg-gray-900 overflow-hidden">
      <div className="h-[64px] relative bg-white border-b z-50">
        <Header />
      </div>
      <div
        className="absolute top-[64px] bottom-0 left-0 right-0 w-full"
        ref={containerRef}
      ></div>
    </div>
  );
};

export default VideoCall;
